import React from "react";
import "./BlendSafeClosingFooter.css";

const groups = [
  { title: "Explore", links: [["How it works", "/#how"], ["Routine Checker", "/routine"], ["Pro", "/pro"], ["Categories", "/categories"], ["Pricing", "/pricing"], ["FAQ", "/faq"]] },
  { title: "Our approach", links: [["Methodology", "/methodology"], ["About BlendSafe", "/about"]] },
  { title: "Help & legal", links: [["Support", "mailto:hello@blendsafe.com"], ["Privacy", "/privacy"], ["Terms", "/terms"], ["Disclaimer", "/disclaimer"], ["Cookies", "/cookies"]] }
];

/** Homepage only. Existing footer stays on all other routes. */
export default function BlendSafeClosingFooter({ year = new Date().getFullYear(), logoSrc = "/images/blendsafe-footer-logo.png", checkHref = "/check", linkGroups = groups }) {
  return <footer className="bs-ending" data-testid="blendsafe-closing-footer">
    <div className="bs-ending__shell">
      <div className="bs-ending__cta">
        <div><h2>Ready to check your skincare?</h2><p>Explore the available findings for your skincare and medication.</p></div>
        <a className="bs-ending__button" href={checkHref} data-testid="closing-footer-cta">Run a free check <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 12h16m-6-6 6 6-6 6" /></svg></a>
      </div>
      <div className="bs-ending__navigation">
        <a className="bs-ending__logo" href="/" aria-label="BlendSafe home"><img src={logoSrc} alt="BlendSafe — Skincare × Medication Safety" width="1906" height="825" loading="lazy" /></a>
        <div className="bs-ending__groups">{linkGroups.map(group => <nav key={group.title} aria-label={`Footer ${group.title}`}><h3>{group.title}</h3><ul>{group.links.map(([label, href]) => <li key={label}><a href={href} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{label}</a></li>)}</ul></nav>)}</div>
      </div>
      <div className="bs-ending__scene">
        <span className="bs-ending__wordmark" aria-hidden="true">BlendSafe</span>
        <div className="bs-ending__legal"><span>© {year} BlendSafe</span><span>Informational tool · Not medical advice</span></div>
      </div>
    </div>
  </footer>;
}
